// 7.2.2 IsArray(argument)
var cof = require('./$.cof');
module.exports = Array.isArray || function(arg){
  return cof(arg) == 'Array';
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.is-array.js
// module id = ./node_modules/core-js/library/modules/$.is-array.js
// module chunks = 2